//This Factory is used to replace the patient with given word by practice
// Why we are Replacing PAtient With another word in some practices like behavioural they call users as client insted of patient
// so for that cause we are given the factory to replace patient
//EMRAdmin.factory('CommonFactoryToReplacePatient', [function () {
var replaceWithValue;
// var replaceWithValue = 'Client';

/**
 * This function is used t set the value of variable  replaceWithValue
 * @param {string} valueToReplaceInPatient
 * @returns {void}
 */
function SetValueNeedToReplaceInPlaceOfPatient(valueToReplaceInPatient) {
    replaceWithValue = valueToReplaceInPatient;
}

function getValueNeedToReplaceInPlaceOfPatient() {
    return replaceWithValue;
}

/**  
 *   
 * @param {any} object  
 * @param {Array} propertiesList  
 * @returns {void} 
 *
 * //Continuesly it will be called until use single bind
 * //to reflect changes in oldValuesMap need to put that in set method
 */
function replaceScopelevelPoperties(object, propertiesList) {
    if (!propertiesList || !propertiesList.length) return
    //  getValueToReplace().then(function (replaceWithValue) {

    // debugger;
    if (replaceWithValue) {
        var oldValuesMap = {};
        _.forEach(propertiesList, function (propName) { oldValuesMap[propName] = object[propName] })
        _.forEach(propertiesList, function (eachProperty) {
            Object.defineProperty(object, eachProperty, {
                get: function () {
                    return !oldValuesMap[eachProperty] || oldValuesMap[eachProperty].indexOf('Patient') === -1 ? oldValuesMap[eachProperty] : oldValuesMap[eachProperty].replace(/Patient/g, replaceWithValue)
                    // this logic changes based on static scope property or dynamic scope property 
                    //return object[eachProperty].indexOf('Patient') === -1 ? object['_' + eachProperty] : object['_' + eachProperty].replace('Patient', replaceWithValue)
                },
                //set: function (value) {
                //    object['_' + eachProperty] = value
                //}
                //})
            });
        })
    }
}
/**
 * This method to Replace Patient of Grid Colums with given value
 * @param {Array} gridColumns
 * @author Supraja Kapa
 * @since 04152020
 */
function replaceGridColums(gridColumns) {
    //checking required values
    if (replaceWithValue && gridColumns && gridColumns.length > 0) {
        //looping through grid columns and replacing Patient with given value
        for (var gridColumnIndex = 0; gridColumnIndex < gridColumns.length; gridColumnIndex++) {
            if (gridColumns[gridColumnIndex].title) {
                gridColumns[gridColumnIndex].title = gridColumns[gridColumnIndex].title.replace('Patient', replaceWithValue);
            }
        }
    }
    return gridColumns;
}
/**
 * 
 * @param {Object} object
 * @param {string} widgetsName
 * @param {string} gridName
 */
function replaceGridColumsUsingScope(object, widgetsName, gridName) {

    if (replaceWithValue) {
        //getting grid data by using kendo grid scope variable 
        var grid = object[widgetsName][gridName];
        if (grid) {
            //getting the grid options data to a vaiable
            var gridOptions = grid.getOptions();
            //if grid options and cloums data is present we need to Send grid columns data to replace Patient with give value by practice
            if (gridOptions && gridOptions.columns && gridOptions.columns.length > 0) {
                var gridColumns = gridOptions.columns
                //looping through grid columns and replacing Patient with given value
                for (var gridColumnIndex = 0; gridColumnIndex < gridColumns.length; gridColumnIndex++) {
                    if (gridColumns[gridColumnIndex].title) {
                        gridColumns[gridColumnIndex].title = gridColumns[gridColumnIndex].title.replace('Patient', replaceWithValue);
                    }
                }
                //assigning the columns to the grid
                grid.setOptions({ columns: gridColumns });
            }
        }
    }
}


    //return {
    //    getValueNeedToReplaceInPlaceOfPatient: getValueNeedToReplaceInPlaceOfPatient,
    //    replaceScopelevelPoperties: replaceScopelevelPoperties,
    //    replaceGridColums: replaceGridColums,
    //    replaceGridColumsUsingScope: replaceGridColumsUsingScope,
    //    SetValueNeedToReplaceInPlaceOfPatient: SetValueNeedToReplaceInPlaceOfPatient,
    //}


//}]);